<template>
  <div v-if="loaded">
    <call-to-actions
      :alignment="ctaAlignment"
      :call-to-actions="callToActions"
      :current-video="currentVideoShared"
      @click-call-to-action="clickCallToAction"
    ></call-to-actions>
  </div>
</template>

<script>
import $ from 'jquery'

import SectionMixin from './section-mixin'
import CallToActions from '../video/show/call-to-actions.vue'
import { hex_to_rgb, readable_color } from '../../utils'
import constants from '@/generated/constants.js'

export default {
  name: 'CtaSection',
  components: { CallToActions },
  mixins: [SectionMixin],
  props: {
    ctaColor: {
      type: String,
      default: constants.GLOBAL.DUBB_BLUE
    },
    ctaAlignment: {
      type: String,
      default: 'center'
    }
  },
  watch: {
    video (newVal) {
      if (newVal) {
        this.initTrackData(newVal.canonical)
      }
    }
  },
  mounted () {
    this.setCTAColor()
  },
  methods: {
    setCTAColor () {
      const rootStyle = $(':root')[0].style
      rootStyle.setProperty('--cta-color', hex_to_rgb(this.ctaColor).join(','))
      rootStyle.setProperty('--cta-text-color', readable_color(this.ctaColor).join(','))
    }
  }
}
</script>
